import React from 'react'

import { Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'

import TabWorkSafety from './components/TabWorkSafety'
import { WorkSafetyProvider } from './context'

const WorkSafetyComponent: React.FC = () => {
  const { tabs, handleChangeTab, selectedTab } = useTabs([
    'Segurança do Trabalho'
  ])

  return (
    <>
      <Tab
        tabs={tabs}
        handleChange={handleChangeTab}
        value={selectedTab.position}
      />
      {selectedTab.position === 0 && <TabWorkSafety />}
    </>
  )
}

const WorkSafety: React.FC = () => {
  return (
    <TabsProvider>
      <WorkSafetyProvider>
        <WorkSafetyComponent />
      </WorkSafetyProvider>
    </TabsProvider>
  )
}

export default WorkSafety
